import m, {Vnode} from "mithril";
const s = require("underscore.string");

export default class FileItem {
    private static EXTENSION_TO_ICON:{[extension:string]: string} = {
        'txt': 'document-text',
        'pdf': 'document-text',
        'doc': 'file-word-box',
        'docx': 'file-word-box',
        'odt': 'file-word-box',
        'pages': 'file-word-box',
        'xls': 'file-excel-box',
        'xlsx': 'file-excel-box',
        'numbers': 'file-excel-box',
        'ods': 'file-excel-box',
        'ppt': 'file-powerpoint-box',
        'pptx': 'file-powerpoint-box',
        'odp': 'file-powerpoint-box',
        'key': 'file-powerpoint-box',
        'mp3': 'file-music',
        'flac': 'file-music',
        'wav': 'file-music',
        'wma': 'file-music',
        'aac': 'file-music',
        'arm': 'file-music',
        'm4a': 'file-music',
        'mp4': 'file-video',
        'webm': 'file-video',
        'mkv': 'file-video',
        'avi': 'file-video',
        '3gp': 'file-video',
        'flv': 'file-video',
        'wmv': 'file-video',
    };


    constructor(
        public readonly content: string,
        public readonly file: File,
        private readonly onDelete: ((fileItem: FileItem) => void)|null = null,
    ) { }

    public view(): Vnode {
        return m('.fileItem.fade-in-zoom.type-'+this.type, {}, [
            this.type === "image" ? this.viewImage() : this.viewOther(),
            this.onDelete ? m('span.delete', {
                onclick: () => {this.onDelete ? this.onDelete(this) : null;}
            }, m.trust('&times;')) : null,
            m('.filename', {}, this.file.name)
        ]);
    }

    private viewImage(): Vnode {
        return m('img', {
            draggable: false,
            src: this.content
        })
    }

    private viewOther(): Vnode {
        const extension = this.file.name.split('.').pop() || 'file';
        const icon = FileItem.EXTENSION_TO_ICON[extension] || 'file'
        return m('i.icon.icon-'+icon);
    }

    public get type(): string {
        return s(this.file.type).startsWith("image") ? "image" : "other";
    }

}
